<template>
  <div>
    <!-- banners -->
    <div class="topbanner">
      <div style="width:100%;">
        <el-carousel :interval="3000" arrow="never" :height="img_height == 0 ? 900 +'px' :  img_height  + 'px'">
          <el-carousel-item key="111">
              <img src="../assets/image/index/banner2.jpg" ref='img_ref' class="banner_img" alt="banner2"/>
          </el-carousel-item>
          <el-carousel-item key="222">
            <img src="../assets/image/index/banner3.jpg" ref='img_ref' class="banner_img" alt="banner3"/>
          </el-carousel-item>
          <el-carousel-item key="333">
            <img src="../assets/image/index/banner4.jpg" ref='img_ref' class="banner_img" alt="banner4"/>
          </el-carousel-item>
          <el-carousel-item key="444">
            <img src="../assets/image/index/banner5.jpg" ref='img_ref' class="banner_img" alt="banner5"/>
          </el-carousel-item>
          <el-carousel-item key="555">
            <img src="../assets/image/index/banner1.jpg" ref='img_ref' class="banner_img" alt="banner1"/>
          </el-carousel-item>

        </el-carousel>
      </div>
    </div>

    <!-- 产品服务-->
    <div class="wd100 pdtop" style="width: 1255px; margin: 0px auto;">
      <div>
        <span style="font-size: 24px;font-weight: 800">产品与服务 <span
          style="font-size: 16px;font-weight: 600;color: #656363">Products & solutions</span></span>
        <span style="float: right;color: #0788dc;cursor: pointer" @click="active('/productAndService')">更多 》</span>
      </div>
      <div class="services-container fade-in-up">


        <div class="service-item" @click="active('/digitalsoftware')">
          <img src="../assets/image/index/service6.png" alt="数字化软件">
          <h3>数字化软件</h3>
          <p>
            利用数字技术研发的应用工具，旨在将传统业务流程转化为高效、智能的数字化形式。它通过自动化处理、数据集成和实时分析，优化管理流程，提升决策效率。数字化软件广泛应用于企业（如ERP系统）、教育（如在线学习平台）、医疗（如电子病历）等领域，助力组织降本增效，增强用户体验。</p>
        </div>

        <div class="service-item" @click="active('/intellectualProperty')">
          <img src="../assets/image/index/service1.png" alt="知识产权">
          <h3>知识产权</h3>
          <p>
            致力于为企业提供全方位的个性化知识产权战略咨询及整体解决方案，涵盖专利、商标、计算机软件著作权、版权等方面的申请、注册、许可、转让、评估等服务。</p>
        </div>

        <div class="service-item" @click="active('/parkServices')">
          <img src="../assets/image/index/service5.png" alt="园区服务">
          <h3>园区服务</h3>
          <p>
            基于丰富的国家高新技术企业培育入库、认证申报辅导经验及完整的服务体系，凭借科学、严谨、规范的咨询服务流程和体系，帮助园区整合外部资源，搭建园区服务科技平台，推动企业自身科技能力和产品升级，提高园区核心竞争力，帮助园区进行高新技术企业认定。</p>
        </div>

        <div class="service-item" @click="active('/projectApplication')">
          <img src="../assets/image/index/service3.png" alt="项目申报">
          <h3>项目申报</h3>
          <p>
            专注于为湖北地区各类科技型企业、农业企业提供科技项目申报、税收优惠减免、知识产权申报、技术转移、成果对接等多方面的业务咨询与服务，全面提升企业科技研发能力、品牌形象和市场竞争力。</p>
        </div>

        <div class="service-item" @click="active('/qualifications')">
          <img src="../assets/image/index/service2.png" alt="资质认定">
          <h3>资质认定</h3>
          <p>
            积极响应政府倡导和政策指引，密切关注质量提升和社会消费的趋势，坚持客户至上的服务宗旨，潜心致力于通过认证帮助客户提高产品和服务质量，促成各界的交流与合作，促进市场诚信体系与和谐社会建设。</p>
        </div>

        <div class="service-item" @click="active('/financialAudit')">
          <img src="../assets/image/index/service4.png" alt="财税审计">
          <h3>财税审计</h3>
          <p>
            专注于对企业财务和税务状况进行独立检查，旨在确保财务信息的真实性、准确性和税务合规性。服务涵盖财务报表审计、税务合规审计、内部控制评估及风险管理，帮助企业识别潜在问题，降低经营和税务风险，优化财税管理。</p>
        </div>


      </div>
    </div>

    <!--关于我们-->
    <div style="margin-top: 120px;width: 100%;">
      <img src="../assets/image/index/zu19.png" alt="关于我们" style="width: 100%; height: auto;">
      <div class="overlay">
        <div class="number-box">
          <span class="count1">1800</span><span>+</span>
          <p>年服务企业</p>
        </div>
        <div class="number-box">
          <span  class="count2">500</span><span>+</span>
          <p>累计辅导高新企业认定</p>
        </div>
        <div class="number-box">
          <span class="count3">200</span><span>+</span>
          <p>累计辅导专精特新企业</p>
        </div>
        <div class="number-box">
          <span class="count4">10000</span><span>+</span>
          <p>知识产权申请</p>
        </div>
      </div>
    </div>

    <!--    产品服务-->
    <div class="wd100 pdtop" style="width: 1255px;margin: 0px auto;position: relative;z-index: 199;margin-top: 30px">
      <div class="container">
        <div class="about-us fade-in-up">
          <img src="../assets/image/index/us.jpeg" alt="关于我们" style="width: 470px;height: 322px">
          <div class="about-us-content">
            <h2 class="about-us-title">关于我们 About US</h2>
            <p class="about-us-description">
              恩施安贝森科技服务股份有限公司（以下简称“安贝森科服”），是一家本土专业从事知识产权、科技项目服务平台。公司秉持“贴近客户、诚信服务、专业水准”的核心价值观，通过个性化服务方案定制、严格保密协议保障及资深专家团队支持，构建起值得信赖的服务体系。
            </p>
            <p class="about-us-description">
              在业务实践中，安贝森科服聚焦技术创新与商业模式升级双重维度，提供涵盖知识产权战略布局、科技项目精准申报、商业模式优化创新的一站式解决方案。通过深度诊断企业创新痛点，整合政府、高校及产业资源，助力企业突破技术壁垒，构建核心竞争力。公司已成功服务多家科技企业，通过定制化服务助力其实现快速成长，获得客户高度认可。
            </p>
            <a href="#" class="about-us-button" @click="active('/aboutsUs')">了解详情</a>
          </div>
        </div>
      </div>
    </div>

    <!--企业动态-->
    <div class="qycontainerdiv fade-in-up">
      <div class="header">
        <h1>企业动态 Company dynamics</h1>
        <a @click="active('/news')" style="cursor: pointer">更多 »</a>
      </div>
      <div class="news-items" style="cursor: pointer">
        <div class="news-item" v-for="(item, index) in records.slice(0, 2)" :key="index" @click="linkUrl(item.linkUrl)">
          <img :src="item.img" alt="新闻图片1" style="width: 354px;height: 209px">
          <h2 style="width: 354px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{item.title}}</h2>
          <p style="display: -webkit-box;-webkit-line-clamp: 6;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;"> &nbsp;&nbsp; &nbsp;&nbsp;{{item.messageOne}}</p>
        </div>
        <div class="latest-news">
          <h2 style="text-align: center">最&nbsp;新&nbsp;动&nbsp;态</h2>
          <ul>
            <li v-for="(item, index) in records.slice(0, 5)">
              <a :href="item.linkUrl" target="_blank" style="width: 330px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{item.title}}</a>
              <span>{{ formatPublishTime(item.publishTime) }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!--荣誉-->
    <div class="honor-container fade-in-up">
      <div class="honor-header">
        <h1>荣誉资质 Qualification honor</h1>
        <a @click="active('/aboutsUsRy')" style="cursor: pointer">更多 »</a>
      </div>
      <div class="honor-certificates">
        <div class="honor-certificate-item">
          <el-image :src="require('../assets/image/rongyu/01.png')" :preview-src-list="srcList"></el-image>
        </div>
        <div class="honor-certificate-item">
          <el-image :src="require('../assets/image/rongyu/yy1.png')" :preview-src-list="srcList"></el-image>
        </div>
        <div class="honor-certificate-item">
          <el-image :src="require('../assets/image/rongyu/yy2.png')" :preview-src-list="srcList"></el-image>
        </div>
        <div class="honor-certificate-item">
          <el-image :src="require('../assets/image/rongyu/yy3.png')" :preview-src-list="srcList"></el-image>
        </div>
        <div class="honor-certificate-item">
          <el-image :src="require('../assets/image/rongyu/yy4.jpg')" :preview-src-list="srcList"></el-image>
        </div>
        <div class="honor-certificate-item">
          <el-image :src="require('../assets/image/rongyu/yy5.jpg')" :preview-src-list="srcList"></el-image>
        </div>
        <div class="honor-certificate-item">
          <el-image :src="require('../assets/image/rongyu/yy6.png')" :preview-src-list="srcList"></el-image>
        </div>
        <div class="honor-certificate-item">
          <el-image :src="require('../assets/image/rongyu/yy7.png')" :preview-src-list="srcList"></el-image>
        </div>
      </div>
    </div>

    <div class="experience-section">
      <h2>请专业顾问为您解答或演示</h2>
      <p>留下您的姓名和联系方式，会有专业人员免费为您服务</p>
      <el-button class="experience-button" @click="showDialog = true">立即体验</el-button>
    </div>
    <!-- 引入弹窗组件 -->
    <call-me-dialog v-if="showDialog" :visible.sync="showDialog" />
  </div>

</template>
<style scoped>
@import './index.css';
</style>
<script>

import CallMeDialog from "../components/CallMeDialog.vue";
import axios from 'axios';

// 创建API客户端（针对8089端口）
const apiClient = axios.create({
  baseURL: process.env.NODE_ENV === 'production'
    ? '/jeecg-boot'
    : 'http://127.0.0.1:8089/jeecg-boot',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
});

// 添加请求拦截器
apiClient.interceptors.request.use(config => {
  // 开发环境添加特殊头，帮助调试CORS
  if (process.env.NODE_ENV === 'development') {
    config.headers['X-Debug-Origin'] = window.location.origin;
  }
  return config;
});

document.addEventListener('DOMContentLoaded', function() {
  const animatedElements = document.querySelectorAll('.fade-in-up');

  const numberElement1 = document.querySelector('.count1'); // 获取数字容器
  const numberElement2 = document.querySelector('.count2'); // 获取数字容器
  const numberElement3 = document.querySelector('.count3'); // 获取数字容器
  const numberElement4 = document.querySelector('.count4'); // 获取数字容器
  const targetNumber1 = 1800; // 目标数值
  const targetNumber2 = 500; // 目标数值
  const targetNumber3 = 200; // 目标数值
  const targetNumber4 = 10000; // 目标数值
  const duration = 2000; // 动画时长（单位：毫秒，与CSS动画2秒匹配）

  if (!animatedElements.length) return;

  let observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // 当元素进入视口时添加.show类以触发动画
        entry.target.classList.add('show111');
        startNumberAnimation(); // 触发数字动画
        observer.unobserve(entry.target); // 停止观察以避免重复动画
      }
    });
  }, { threshold: 0.3 }); // 调整threshold值可以控制动画触发时机

  // 数字递增函数
  function startNumberAnimation() {
    let startTimestamp = null;

    const updateNumber = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = timestamp - startTimestamp;
      const percentage = Math.min(progress / duration, 1); // 计算进度百分比

      // 使用缓动函数（ease-out）
      const easedPercentage = 1 - Math.pow(1 - percentage, 2);

      const currentNumber1 = Math.floor(targetNumber1 * easedPercentage);
      const currentNumber2 = Math.floor(targetNumber1 * easedPercentage);
      const currentNumber3 = Math.floor(targetNumber1 * easedPercentage);
      const currentNumber4 = Math.floor(targetNumber1 * easedPercentage);
      numberElement1.textContent = currentNumber1;
      numberElement2.textContent = currentNumber2;
      numberElement3.textContent = currentNumber3;
      numberElement4.textContent = currentNumber4;

      if (percentage < 1) {
        requestAnimationFrame(updateNumber);
      } else {
        numberElement1.textContent = targetNumber1; // 确保最终值精确
        numberElement2.textContent = targetNumber2; // 确保最终值精确
        numberElement3.textContent = targetNumber3; // 确保最终值精确
        numberElement4.textContent = targetNumber4; // 确保最终值精确
      }
    };

    requestAnimationFrame(updateNumber);
  }

  animatedElements.forEach(element => {
    observer.observe(element);
  });
});
export default {
  data() {
    return {
      showDialog: false,
      input: '',
      code: '',
      value: '',
      value2: '',
      imgList: [],
      img_height: '',
      area_code: '3c205bf5fd744514b2c19720d1d80381',
      srcList: [
        require("../assets/image/rongyu/01.png"),
        require("../assets/image/rongyu/yy2.png"),
        require("../assets/image/rongyu/yy3.png"),
        require("../assets/image/rongyu/yy4.jpg"),
        require("../assets/image/rongyu/yy5.jpg"),
        require("../assets/image/rongyu/yy6.png"),
        require("../assets/image/rongyu/yy7.png"),
        require("../assets/image/rongyu/yy8.png"),
      ],
      formData: {
        pageNo: 1,
        pageSize: 5,
        type: 2, // type，0=公司动态，1=行业新闻，2=媒体报道
      },
      records:[]
    }
  },
  components: {CallMeDialog},
  mounted() {
    this.initAnimationObserver(); // 添加这行
    this.getList(); // 添加这行
  },

  methods: {
    formatPublishTime(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2); // Months are zero-based
      const day = ('0' + date.getDate()).slice(-2);
      return `${year}年${month}月${day}日`;
    },
    async getList(){
      const res =  await  apiClient.get('/newsCenter/newsCenter/list', {
        params: this.formData, // 使用 params 来传递查询参数
        // 显式设置凭证模式为 false
        withCredentials: false,

        // 添加额外的CORS相关头
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Sec-Fetch-Mode': 'cors'
        }
      });
      if (res.data.success) {
        this.records = res.data.result.records
      }
    },
    initAnimationObserver(){
      const animatedElements = document.querySelectorAll('.fade-in-up');

      if (!animatedElements.length) return;

      let observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('show');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.3, rootMargin: '0px 0px -100px 0px' });

      animatedElements.forEach(element => {
        observer.observe(element);
      });
    },
    active(url) {
      this.$router.push(url);
    },
    linkUrl(url){
      window.open(url);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/index.vue